<h3 mat-dialog-title class="title">
  {{ 'catalog.changeSets.convertChangeSetDialog.title' | translate }}
</h3>

<mat-dialog-content>
    <div class="content"
         [innerHTML]="'catalog.changeSets.convertChangeSetDialog.message' | translate:{version: capitalizeVersion(this.oppositeVersion)}">
    </div>
    <div class="content"
         *ngIf="!!data.oppositeVersion"
         [innerHTML]="'catalog.changeSets.convertChangeSetDialog.oppositeVersionMessage' | translate:{version: capitalizeVersion(this.oppositeVersion)}">
    </div>

    <div *ngIf="changeSet.type === 'DRAFT'">
      {{ 'catalog.changeSets.scheduledDateDialog.message' | translate }}
    </div>
    <br>

    <mat-form-field *ngIf="changeSet.type === 'DRAFT'">
      <mat-label>{{ 'catalog.changeSets.convertChangeSetDialog.label' | translate }}</mat-label>
      <input matInput
             [min]="minDate"
             [formControl]="scheduleDateControl"
             (dateChange)="onScheduleDateChange($event)"
             [ngxMatDatetimePicker]="dateForSchedule"
             required>
      <mat-hint>
        {{ 'catalog.changeSets.convertChangeSetDialog.hint' | translate }}
      </mat-hint>
      <mat-datepicker-toggle matSuffix [for]="$any(dateForSchedule)">
      </mat-datepicker-toggle>
      <ngx-mat-datetime-picker #dateForSchedule
                               [showSpinners]="true"
                               [color]="color"
                               [enableMeridian]="true">
        <ngx-mat-datepicker-actions>
            <button color="primary" ngxMatDatepickerApply mat-icon-button
                [attr.aria-label]="'form.button.select' | translate ">
                <i class="tce-icon-checkmark"></i>
            </button>
        </ngx-mat-datepicker-actions>
      </ngx-mat-datetime-picker>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <txp-button (click)="onCancel()"
        data-qa-label="CancelButton"
        [style]="buttonStyle.SECONDARY"
        [disabled]="isSaving">
        {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button data-qa-label="ContinueButton"
        [style]="buttonStyle.PRIMARY"
        (click)="onSave()"
        [loading]="isSaving"
        [disabled]="disableContinueBtn" >
        {{ 'form.button.save' | translate }}
    </txp-button>
</mat-dialog-actions>
